import { render, staticRenderFns } from "./ProInput.vue?vue&type=template&id=647ebff6&scoped=true&lang=pug&"
import script from "./ProInput.vue?vue&type=script&lang=js&"
export * from "./ProInput.vue?vue&type=script&lang=js&"
import style0 from "./ProInput.vue?vue&type=style&index=0&id=647ebff6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ebff6",
  null
  
)

export default component.exports